module.exports = __webpack_public_path__ + "static/media/new1.94f1c00f.png";